module.exports = __webpack_public_path__ + "img/c04_unitstartechhandcart_Normal_ua.74168830.webp";